import "core-js/modules/web.timers";
import { __decorate, __extends } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PopupComponent from '@/components/messageBox/popup';

var FirstDayPopup =
/** @class */
function (_super) {
  __extends(FirstDayPopup, _super);

  function FirstDayPopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.active = false;
    return _this;
  }
  /**
   * 点击打卡
   */


  FirstDayPopup.prototype.onClick = function () {
    this.value = false;
  };

  FirstDayPopup.prototype.mounted = function () {
    var _this = this;

    setTimeout(function () {
      _this.active = true;
    }, 100);
  };

  FirstDayPopup = __decorate([Component({
    name: 'FirstDayPopup',
    template: "<MyPopup v-model=\"value\" :content-class=\"['first-day-popup']\" position=\"center\" :modal=\"true\">\n        <img class=\"ticket-slot\" v-thumbnail=\"'/meta/activity_3/popup/first_day/ticket_slot.png'\" />\n        <div class=\"ticket-content-wrap\">\n            <div class=\"ticket-content\" :class=\"{active: active}\" v-thumbnail:background-image=\"'/meta/activity_3/popup/first_day/ticket_content.png'\">\n                <MobileButton name=\"c9c0f1e\" class=\"btn-normal btn-rect\" @click=\"onClick\">\u6211 \u77E5 \u9053 \u4E86</MobileButton>\n            </div>\n        </div>\n        <img class=\"ticket-content-shadow\" v-thumbnail=\"'/meta/activity_3/popup/first_day/ticket_content_shadow.png'\" />\n    </MyPopup>"
  })], FirstDayPopup);
  return FirstDayPopup;
}(Mixins(PopupComponent));

export { FirstDayPopup };